import { Client } from '@/utils';
import { positionDetail as positionDetailAPI } from '@/api';

const GET_POSITIONTLIST = 'positionDetail/GET_POSITIONTLIST';
const GET_STATUSMARKFUNCTIONAL = 'positionDetail/GET_STATUSMARKFUNCTIONAL';
const GET_POSTYPERANK = 'positionDetail/GET_POSTYPERANK';
const GET_FUNCLISTBYDEPT = 'positionDetail/GET_FUNCLISTBYDEPT';

export default {
    state:{
        tableData:{},
        statusMarkFunctional:{},
        posTypeRank:{},
        funListByDept:[],
        funListByDeptSysType:[],
    },
    actions:{
        async [GET_POSITIONTLIST]({ commit }, { params = {}, frontCode = '' } = {}) {
            commit(GET_POSITIONTLIST, await Client.get(positionDetailAPI.getPositionList, { params }, frontCode));
        },
        async [GET_STATUSMARKFUNCTIONAL]({ commit }, { params = {}, frontCode = '' } = {}) {
            commit(GET_STATUSMARKFUNCTIONAL, await Client.get(positionDetailAPI.getStatusMarkFunctional, { params }, frontCode,false));
        },
        async [GET_POSTYPERANK]({ commit }, { params = {}, frontCode = '' } = {}) {
            commit(GET_POSTYPERANK, await Client.get(positionDetailAPI.getPosTypeRank, { params }, frontCode,false));
        },
        async [GET_FUNCLISTBYDEPT]({ commit }, { params = {}, frontCode = '' } = {}) {
            commit(GET_FUNCLISTBYDEPT, {
                params:params,
                data:await Client.get(positionDetailAPI.getFunListByDept, { params }, frontCode,false)
            });
        },
    },
    mutations:{
        [GET_POSITIONTLIST](state,data) {
            state.tableData = data;
        },
        [GET_STATUSMARKFUNCTIONAL](state,data) {
            state.statusMarkFunctional = data;
        },
        [GET_POSTYPERANK](state,data) {
            state.posTypeRank = data;
        },
        [GET_FUNCLISTBYDEPT](state,payload) {
            if(payload.params.deptId){
                if(payload.params.types && payload.params.systemId){
                    state.funListByDeptSysType = payload.data.functional;
                }else{
                    state.funListByDept = payload.data.functional;
                }
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/positionDetail.js